/**
 * Supra — Predictive search for the header overlay
 *
 * Markup contract (sections/supra-header.liquid):
 *   [data-supra-search-input]          -> search input
 *   [data-supra-search-results]        -> hidden container shown when typing
 *   [data-supra-search-status]         -> inline status message
 *   [data-supra-search-groups]         -> results groups wrapper
 *   [data-supra-search-suggest]        -> "Try:" chips (hidden while typing)
 *   [data-supra-search-view-all]       -> "See all results" link (href mutated)
 */
(function () {
  'use strict';
  var input   = document.querySelector('[data-supra-search-input]');
  var overlay = document.querySelector('[data-supra-search]');
  if (!input || !overlay) return;

  var results   = overlay.querySelector('[data-supra-search-results]');
  var groupsEl  = overlay.querySelector('[data-supra-search-groups]');
  var statusEl  = overlay.querySelector('[data-supra-search-status]');
  var suggestEl = overlay.querySelector('[data-supra-search-suggest]');
  var viewAll   = overlay.querySelector('[data-supra-search-view-all]');

  var DEBOUNCE_MS = 140;
  var MIN_LEN = 2;
  var timer = null;
  var lastQuery = '';

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[c];
    });
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function showResults() {
    if (results) { results.hidden = false; }
    if (suggestEl) { suggestEl.hidden = true; }
  }

  function hideResults() {
    if (results) { results.hidden = true; }
    if (suggestEl) { suggestEl.hidden = false; }
    if (groupsEl) { groupsEl.innerHTML = ''; }
    if (statusEl) { statusEl.textContent = ''; }
  }

  function renderEmpty(query) {
    groupsEl.innerHTML =
      '<p class="supra-search__empty">No matches for <strong>' + escapeHtml(query) + '</strong>.<br>' +
      'Try a brand (Jordan, Nike, Yeezy) or a model (Dunk Low, Air Max).</p>';
  }

  function renderResults(data, query) {
    var products    = (data.resources && data.resources.results && data.resources.results.products)    || [];
    var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
    var pages       = (data.resources && data.resources.results && data.resources.results.pages)       || [];
    var queries     = (data.resources && data.resources.results && data.resources.results.queries)     || [];

    var out = [];

    if (queries.length > 0) {
      var qHtml = queries.slice(0, 5).map(function (q) {
        return '<a class="supra-search__suggest-item" href="/search?q=' + encodeURIComponent(q.text) + '">' + escapeHtml(q.text) + '</a>';
      }).join('');
      out.push(
        '<section class="supra-search__group">' +
          '<h4 class="supra-search__group-title">Suggestions</h4>' +
          '<div class="supra-search__suggest-row">' + qHtml + '</div>' +
        '</section>'
      );
    }

    if (products.length > 0) {
      var list = products.slice(0, 12).map(function (p) {
        var img = (p.featured_image && (p.featured_image.url || p.featured_image)) || p.image || '';
        var price = formatMoney(p.price_min || p.price);
        var compare = p.compare_at_price_min && p.compare_at_price_min > (p.price_min || 0) ? formatMoney(p.compare_at_price_min) : '';
        return (
          '<a class="supra-search__item" href="' + escapeHtml(p.url) + '">' +
            '<span class="supra-search__item-thumb" style="background-image:url(' + escapeHtml(img) + ')"></span>' +
            '<span class="supra-search__item-body">' +
              '<span class="supra-search__item-vendor">' + escapeHtml(p.vendor || '') + '</span>' +
              '<span class="supra-search__item-title">' + escapeHtml(p.title) + '</span>' +
            '</span>' +
            '<span class="supra-search__item-price">' +
              (compare ? '<del>' + compare + '</del> ' : '') + price +
            '</span>' +
          '</a>'
        );
      }).join('');
      out.push(
        '<section class="supra-search__group">' +
          '<h4 class="supra-search__group-title">Products</h4>' +
          '<div class="supra-search__product-list">' + list + '</div>' +
        '</section>'
      );
    }

    if (collections.length > 0) {
      var chips = collections.slice(0, 6).map(function (c) {
        return '<a class="supra-search__chip" href="' + escapeHtml(c.url) + '">' + escapeHtml(c.title) + '</a>';
      }).join('');
      out.push(
        '<section class="supra-search__group">' +
          '<h4 class="supra-search__group-title">Collections</h4>' +
          '<div class="supra-search__chip-row">' + chips + '</div>' +
        '</section>'
      );
    }

    if (pages.length > 0) {
      var phtml = pages.slice(0, 4).map(function (p) {
        return '<a class="supra-search__link" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>';
      }).join('');
      out.push(
        '<section class="supra-search__group">' +
          '<h4 class="supra-search__group-title">Help / Pages</h4>' +
          '<div class="supra-search__link-list">' + phtml + '</div>' +
        '</section>'
      );
    }

    if (out.length === 0) {
      renderEmpty(query);
    } else {
      groupsEl.innerHTML = out.join('');
    }

    if (viewAll) {
      viewAll.setAttribute('href', '/search?type=product&q=' + encodeURIComponent(query));
      viewAll.textContent = 'See all results for "' + query + '" →';
    }
  }

  function search(q) {
    if (q === lastQuery) return;
    lastQuery = q;
    showResults();
    statusEl.textContent = 'Searching…';

    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product,collection,page,query'
      + '&resources[limit]=12&resources[limit_scope]=each'
      + '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (q !== lastQuery) return;
        statusEl.textContent = '';
        renderResults(data, q);
      })
      .catch(function () {
        statusEl.textContent = 'Search is unavailable right now.';
      });
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = (input.value || '').trim();
    if (q.length < MIN_LEN) { hideResults(); return; }
    timer = setTimeout(function () { search(q); }, DEBOUNCE_MS);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hideResults();
  });
})();
